import { render, staticRenderFns } from "./SaEditor.vue?vue&type=template&id=913da1d2&scoped=true&"
import script from "./SaEditor.vue?vue&type=script&lang=js&"
export * from "./SaEditor.vue?vue&type=script&lang=js&"
import style0 from "./SaEditor.vue?vue&type=style&index=0&id=913da1d2&scoped=true&lang=css&"
import style1 from "./SaEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913da1d2",
  null
  
)

export default component.exports